import clsx from "clsx";

import styles from "./mobile-form.module.scss";

export const MobileFormControls = ({ children }) => {
  return <div className={styles.MobileControls}>{children}</div>;
};

export const MobileForm = ({ children, showMobileForm }) => {
  return (
    <>
      <div
        className={clsx(
          styles.FormContainer,
          showMobileForm && styles.MobileOpen
        )}
      >
        <div className={clsx(styles.FormTransition)}>{children}</div>
      </div>
    </>
  );
};
